module.exports = __webpack_public_path__ + "img/mensaje_fin_disensa.a7d7bcf5.png";